import { render } from "./Geometric.vue?vue&type=template&id=1267ef04&scoped=true"
import script from "./Geometric.vue?vue&type=script&lang=js"
export * from "./Geometric.vue?vue&type=script&lang=js"

import "./Geometric.vue?vue&type=style&index=0&id=1267ef04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1267ef04"]])

export default __exports__